export default __webpack_public_path__ + "static/08_V1@2x-55a95e8e9cb23e3b71ce8e3f3edfe787.png";